import { useLocation } from 'react-router-dom';
import { useSelector, shallowEqual } from 'react-redux';
import { TradeState, TradeStateEnumMap } from '../../types/trade';

const useCurrentTradeState = (): TradeState => {
  const { pathname } = useLocation();

  const currentTradeState = useSelector(
    state => state.ui?.nav?.secondary?.context,
    shallowEqual
  );
  return TradeStateEnumMap[pathname.split('/')[2]] || currentTradeState;
};

export default useCurrentTradeState;
